<template>
    <v-container class="my-5">
        <h2 class="subheading grey--text">{{ $t('tracking') }}</h2>
        <v-layout class="my-4" align-center justify-center fill-height>
          <v-card width="800px" :loading="loadingAttendance">
            <v-card-title>
              {{$t('tracking_day')}}
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="getTracking">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-show="attendance.length > 0">
              <v-flex v-for="(student, index) in attendance" v-bind:key="index" class="d-none d-md-block">
                <h3>{{student.fullname}}</h3>
                <v-stepper
                    class="mt-2"
                >
                  <v-stepper-header>
                    <v-stepper-step
                        :complete="student.status > 0"
                        step="1"
                    >
                      {{$t('in_school')}}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                        :complete="student.status > 1"
                        step="2"
                    >
                      {{$t('transferred')}}
                      <!--                      <small>Optional</small>-->
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                        :complete="student.status > 2"
                        step="3"
                    >
                      {{$t('exit_enabled')}}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                        :complete="student.status > 3"
                        step="4"
                    >
                      {{$t('out_school')}}
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-flex>
              <v-flex v-for="(student, index) in attendance" v-bind:key="index"  class="d-block d-md-none">
                <h3>{{student.fullname}}</h3>
                <v-stepper
                    vertical
                >
                  <v-stepper-step
                      step="1"
                      :complete="student.status > 0"
                  >
                    {{$t('in_school')}}
                  </v-stepper-step>
                  <v-stepper-content step="1"></v-stepper-content>
                  <v-stepper-step
                      step="2"
                      :complete="student.status > 1"
                  >
                    {{$t('transferred')}}
                    <!--                      <small>Optional</small>-->
                  </v-stepper-step>
                  <v-stepper-content step="2"></v-stepper-content>
                  <v-stepper-step
                      step="3"
                      :complete="student.status > 2"
                  >
                    {{$t('exit_enabled')}}
                  </v-stepper-step>
                  <v-stepper-content step="3"></v-stepper-content>
                  <v-stepper-step
                      step="4"
                      :complete="student.status > 3"
                  >
                    {{$t('out_school')}}
                  </v-stepper-step>
                </v-stepper>
              </v-flex>
            </v-card-text>
            <v-card-text v-show="attendance.length <= 0">
              <h3>{{$t('no_registros')}}</h3>
            </v-card-text>
          </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'tracking',
  created () {
    this.getTracking()
  },
  data: () => ({
    attendance: [],
    loadingAttendance: false,
  }),
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },
  methods: {
    getTracking () {
      this.loadingAttendance = true
      HTTP.get('tracking/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.attendance = response.data
        this.loadingAttendance = false
      })
      .catch(error => {
        this.loadingAttendance = false
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
